import React, {useEffect, useRef, useState} from 'react'
import dayjs from 'dayjs'

import Month from './Month'

import { ReactComponent as NextArrow } from '../../../assets/icons/arrow-next-thin.svg'
import { ReactComponent as PrevArrow } from '../../../assets/icons/arrow-prev-thin.svg'
import './day-picker.scss'

const DatePicker = ({
  date,
  endDate,
  monthsToShow = 1,
  handleSelectDate,
  selectedDates = [],
  isOneWay,
  onOpen,
}) => {
  const [currentDateObj, setCurrentDateObj] = useState(
    date ? dayjs(date) : dayjs()
  )

  const ref = useRef(null)

  useEffect(() => {
    // this is really onMount, this component only mounts if "open"
    if (onOpen && ref?.current) {
      onOpen(ref.current)
    }
  },[]) // eslint-disable-line

  // Current Month
  const currentMonth = currentDateObj.startOf('month')
  const months = Array.from({ length: monthsToShow }, (_, i) =>
    currentMonth.add(i, 'months').startOf('month')
  )

  return (
    <div className="day-picker" ref={ref}>
      <div className="calendar">
        <button
          onClick={(e) => {
            e.preventDefault()
            setCurrentDateObj(currentDateObj.add(-1, 'months'))
          }}
          className="nav-button prev-arrow"
        >
          <PrevArrow />
        </button>
        <button
          onClick={(e) => {
            e.preventDefault()
            setCurrentDateObj(currentDateObj.add(1, 'months'))
          }}
          className="nav-button next-arrow"
        >
          <NextArrow />
        </button>

        {months.map((month) => (
          <Month
            currentMonth={month}
            key={month.format()}
            handleSelectDate={handleSelectDate}
            selectedDates={selectedDates}
            startDate={date}
            endDate={endDate}
            isOneWay={isOneWay}
          />
        ))}
      </div>
    </div>
  )
}

export default DatePicker
